import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { storageItemImageIdZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-id";
import { hexColorZodSchema } from "@@/shared/stylable/hex-color/hex-color";
import {
    asTranslatableValue,
    translatableValueZodObject,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { pageIdZodSchema } from "../../page-id";

const customContentCreateCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("CUSTOM_CONTENT_CREATE_COMMAND"),
    title: translatableValueZodObject,
    subtitle: translatableValueZodObject.optional(),
    kicker: translatableValueZodObject.optional(),
    actionText: translatableValueZodObject.optional(),
    url: z.string().url().optional(),
    pageId: pageIdZodSchema,
    providerId: providerIdZodSchema.optional(),
    image: storageItemImageIdZodSchema.optional(),
    backgroundColor: hexColorZodSchema.optional(),
    accentColor: hexColorZodSchema.optional(),
    textColor: hexColorZodSchema.optional(),
});
type CustomContentCreateCommand = z.infer<
    typeof customContentCreateCommandZodObject
>;
const customContentCreateCommandZodSchema: z.ZodSchema<CustomContentCreateCommand> =
    customContentCreateCommandZodObject;

type CustomContentCreateCommandFactoryParams = Except<
    CustomContentCreateCommand,
    "_id" | "_type"
>;
const customContentCreateCommandFactory = (
    params: CustomContentCreateCommandFactoryParams,
): CustomContentCreateCommand => {
    return {
        _id: generateId({ prefix: "custom_content_create_command__" }),
        _type: "CUSTOM_CONTENT_CREATE_COMMAND",
        title: asTranslatableValue(params.title),
        subtitle: asTranslatableValue(params.subtitle),
        kicker: asTranslatableValue(params.kicker),
        actionText: asTranslatableValue(params.actionText),
        url: params.url,
        pageId: params.pageId,
        providerId: params.providerId,
        image: params.image,
        backgroundColor: params.backgroundColor,
        accentColor: params.accentColor,
        textColor: params.textColor,
    };
};

export {
    customContentCreateCommandFactory,
    customContentCreateCommandZodObject,
    customContentCreateCommandZodSchema,
};
export type { CustomContentCreateCommand };
